import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { Router, Route, hashHistory } from "react-router";
import DecryptCard from "../src/views/Util/DecryptCard";
import Dashboard from "../src/views/DashBoard/index";
import Users from "./views/Users";
import LoginView from "../src/views/Login";
import ForgetPassword from "../src/views/ForgetPassword";
import { loggedIn } from "../src/views/Login/authUtil";
import MakeATransaction from "../src/views/Cielo/MakeATransaction";
import Transactions from "../src/views/Cielo/Transactions";
import CancelPurchase from "../src/views/Cielo/cancelPurchase";
import MakeSolicitation from "../src/views/PaymentSolicitation/makesolicitation";
import PaymentSolicitation from "../src/views/PaymentSolicitation/index";
import RaceSolicitation from "../src/views/RaceSolicitation/index";
import RacesHistoric from "../src/views/RacesHistoric/index";
import DisableDriver from "../src/views/DisableDriver/index";
import Report from "./views/Reports";
import FinancialReport from "./views/FinancialReports";
import DriverReport from "./views/DriverReports";
import ReportRender from "./views/Reports/report-render";
import { Invoice } from "./views/Invoice";
import Wallet from "./views/Wallet";
import WalletReports from "./views/WalletReports";
import Establishment from "./views/Establishment";
import RainTax from "../src/views/RainTax/index";
import AdminPage from "../src/views/Admin/index";
import MotoboysPayment from "./views/MotoboysPayment";
//import Account from "../src/views/Admin/account/index";

function requireAuth(nextState, replace) {
  if (!loggedIn()) {
    replace({
      pathname: "/",
    });
  }
}

let isSuperUser = localStorage.getItem('is_super_user');
let establishmentId = localStorage.getItem('id_establishment');
console.log(typeof isSuperUser);

ReactDOM.render(
  <Router history={hashHistory}>
    <Route component={App}>
      {isSuperUser === 'true' && establishmentId === '577' ? (<Route path="/home/dashboard" component={Dashboard} />) : ''}
      <Route
        path="/home/card/card-decrypt"
        component={DecryptCard}
      // onEnter={requireAuth}
      />
      <Route
        path="/home/cielo/MakeATrasactionView"
        component={MakeATransaction}
      // onEnter={requireAuth}
      />
      <Route
        path="/home/cielo/transactions"
        component={Transactions}
      // onEnter={requireAuth}
      />
      <Route
        path="/home/users"
        component={Users}
      // onEnter={requireAuth}
      />
      <Route
        path="/home/makesolicitation/:id"
        component={MakeSolicitation}
      // onEnter={requireAuth}
      />

      <Route
        path="/home/solicitations/"
        component={PaymentSolicitation}
      // onEnter={requireAuth}
      />
      <Route
        path="/home/racesolicitations/"
        component={RaceSolicitation}
      // onEnter={requireAuth}
      />
      <Route
        path="/home/raceshistoric/"
        component={RacesHistoric}
      // onEnter={requireAuth}
      />
      <Route
        path="/home/disabledriver/"
        component={DisableDriver}
      // onEnter={requireAuth}
      />
      <Route
        path="/home/cielo/cancelPurchase"
        component={CancelPurchase}
      // onEnter={requireAuth}
      />
      <Route
        path="/home/report"
        component={Report}
      // onEnter={requireAuth}
      />
      <Route
        path="/home/financialReport"
        component={FinancialReport}
      // onEnter={requireAuth}
      />

      <Route
        path="/home/driverReport"
        component={DriverReport}
      // onEnter={requireAuth}
      />

      <Route
        path="/home/wallet"
        component={Wallet}
      // onEnter={requireAuth}
      />

      <Route
        path="/home/wallet/reports"
        component={WalletReports}
      // onEnter={requireAuth}
      />
      {isSuperUser === 'true' ? (<Route path="/home/establishment" component={Establishment} />) : ''}
      {isSuperUser === 'true' ? (<Route path="/home/motoboys-payment" component={MotoboysPayment} />) : ''}
      {/* <Route
        path="/home/yzzer/cancelPurchase"
        component={CancelPurchase}
        // onEnter={requireAuth}
      /> */}
      {isSuperUser === 'true' && establishmentId === '577' ? (<Route path="/home/rainTax" component={RainTax} />) : ''}
      {isSuperUser === 'true' && establishmentId === '577' ? (<Route path="/home/Admin" component={AdminPage} />) : ''}
      {/* {isSuperUser === 'true' && establishmentId === '577' ? (<Route path="/home/Admin/account" component={Account} />) : ''} */}
    </Route>
    <Route path="/forgotPassword" component={ForgetPassword} />
    <Route path="/" component={LoginView} />
    <Route path="/report-render" component={ReportRender} />
    <Route path="/render-cupom/:id" component={Invoice} />
  </Router>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js